$(document).ready(function(){

    mixpanel.track('Page:' + window.location.pathname);

    $('body').addClass('locale-' + Shopify.locale);

    if(window.location.href.includes('account/activate')){
        var queryParams = new URLSearchParams(window.location.search);
        var email = '';
        if(queryParams.has('email')){
            email = queryParams.get('email');
        }

        $('#activation-form input[name="return_to"]').val('/products/direct-download?email=' + email);

        $('form').on('submit', function(event){
            event.preventDefault();

            var error = '';
            var password = $(this).find('input[name="customer[password]"]').val();

            if(password == ''){
                error = "Bitte gebe ein Passwort an.";
            }
            else if(password.length < 6){
                error = "Dein Passwort muss mindestens 6 Zeichen lang sein.";
            }

            // Check for errors.
            if(error != ''){
                $('#direct-download-signup-required-errors').show();
                $('#direct-download-signup-required-errors').html(error);
                return;
            }

            showLoadingIndicator();

            $(this).find('input[name="customer[password_confirmation]"]').val($(this).find('input[name="customer[password]"]').val());

            // Do activation.
            var postUrl = $(this).attr('action');
            var postData = $(this).serialize();

            $.ajax({
                type: "POST",
                url: postUrl,
                data: postData,
                dataType: "json",
                success: function() {
                    // Set password is set.
                    $.ajax({
                        type: "POST",
                        url: 'https://api.getconrise.com/password-is-set', 
                        contentType : 'application/json; charset=utf-8',
                        dataType: "json",
                        data: JSON.stringify({
                            email_address: email
                        }),
                        success: function() {
                            window.location.href = '/products/direct-download?email=' + email;
                        },
                        error: function() {
                            window.location.href = '/products/direct-download?email=' + email;
                        }
                    });
                },
                error: function(response) {
                    hideLoadingIndicator();

                    alert(response.responseText);
                }
            });
        });
    }

    if(window.location.href.includes('pages/discounted-trail-password')){
        var queryParams = new URLSearchParams(window.location.search);
        var email = '';
        var token = '';
        
        if(queryParams.has('email')){
            email = queryParams.get('email');
        }
        if(queryParams.has('token')){
            token = queryParams.get('token');
        }

        $.ajax({
            type: "POST",
            url: 'https://api.getconrise.com/check-setup-password', 
            contentType : 'application/json; charset=utf-8',
            dataType: "json",
            data : JSON.stringify({
                email_address: email
            }),
            success: function(data) {
                if(!data || !data.success){
                    window.location.href = "/account/activate/" + token + '?email=' + email;
                }
                else{
                    window.location.href = '/products/direct-download?email=' + email;
                }
            },
            error: function(response) {
                window.location.href = "/account/activate/" + token;
            }
        });
    }

    if(window.location.href.includes('account/subscribe')){
        window.location.href = "https://getconrise.com/pages/account-confirmed";
    }

    if(window.location.href.includes('pages/account-subscribe-download')){
        showLoadingIndicator();

        var queryParams = new URLSearchParams(window.location.search);
        
        var email = '';
        if(queryParams.has('email')){
            email = queryParams.get('email');
        }

        if(email && email.length > 0){
            mixpanel.identify(email);
        }

        var trafficSource = '';
        if(queryParams.has('source')){
            trafficSource = queryParams.get('source');
        }

        var utmSource = 'Website-' + (window.screen.width < 768 ? 'Mobile' : 'Desktop');
        var url = 'https://getconrise.com/products/v2-download?utm_source=' + utmSource + '&utm_medium=Mail&utm_campaign=&utm_content=&email=' + email + '&show-download-button';

        if(queryParams.has('sub')){
            $('#iframe').on('load', function(){
                // Safe ???
                window.location.href = url;
            });

            $('#iframe').attr('src', 'https://getconrise.com' + queryParams.get('sub'));

            // Fallback for iframe load event.
            setTimeout(function(){
                window.location.href = url;
            }, 3000);
        }
        else{
            window.location.href = url;
        }
    }

    if(
        $('.template-index').length > 0 || 
        $('.page-page-exists').length > 0 || 
        $('.page-direct-download').length > 0 || 
        $('.page-email-download-link').length > 0 || 
        $('.page-discounted-trail-first').length > 0 || 
        $('.page-email-download-link-2').length > 0 || 
        $('.page-email-download-link-3').length > 0 || 
        $('.page-email-download-link-5').length > 0 || 
        $('.page-email-download-link-4').length > 0
    ){
        new Swiper(".index-header-reviews", {
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            autoplay:{
                delay: 4000,
                disableOnInteraction: false
            }
        });

        var selfieVideoSwiper = new Swiper(".index-selfie-videos-content", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: '.index-selfie-videos-navigation .next',
                prevEl: '.index-selfie-videos-navigation .prev',
            }
        });

        if(screen.width > 787 && $('.index-selfie-videos-content').length > 0){
            selfieVideoSwiper.destroy(true, true);
        }

        // ----------------------

        var featuresSwiper = new Swiper(".index-features-content", {
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            navigation: {
                nextEl: '.index-features-navigation .next',
                prevEl: '.index-features-navigation .prev',
            }
        });

        if(screen.width > 787 && $('.index-features-content').length > 0){
            featuresSwiper.destroy(true, true);
        }

        // ----------------------

        var reasonsSwiper = new Swiper(".index-reasons-content", {
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            navigation: {
                nextEl: '.index-reasons-navigation .next',
                prevEl: '.index-reasons-navigation .prev',
            }
        });

        if(screen.width > 970 && $('.index-reasons-content').length > 0){
            reasonsSwiper.destroy(true, true);
        }
    }

    // ----------------------

    if(document.querySelector('.download-link')){
        document.querySelector('.download-link').click();

        $('body').css("background-color", "#faf5ea");

        $('.header-menu').css('justify-content', 'center');
        $('.header-menu-links').hide();

        $('.footer-content').css('justify-content', 'center');
        $('.footer-content-logo').hide();

        $('.footer-content-links a').css("font-size", "12px");
        $('.footer-content-links a').css("opacity", "0.5");
    }

    // -------------------------

    $('.price-faq-content div h5').click(function(){
        $(this).next().toggle();

        if($(this).next().css('display') == 'none'){
            $(this).find('svg').removeClass('open');
        }
        else{
            $(this).find('svg').addClass('open');
        }
    });

    if($('.price-boxes').length > 0){
        $('.index-selfie-videos .btn-container-center a').click(scrollToPrice);
        $('.index-selfie-videos .btn-container-center a').attr('href', '#');

        $('.index-two-options .btn-container-center a').click(scrollToPrice);
        $('.index-two-options .btn-container-center a').attr('href', '#');
    }

    // -------------------------

    $('.account-menu-entry').click(function(){
        $('.account-content').hide();
        $('.account-menu-entry').removeClass('active');

        $('#'+$(this).attr('data-content')).show();
        $(this).addClass('active');

        if(screen.width < 769){
            $('.account-menu').hide();
        }
    });

    // -------------------------

    if($('.template-register').length > 0){
        handleRegister();
    }

    // -------------------------

    if($('.account-confirm').length > 0){
        hideHeaderAndFooter();
    }

    // -------------------------

    if($('.account-confirmed').length > 0){
        hideHeaderAndFooter();
    }

    // -------------------------

    if($('.template-index').length > 0){
        v2Index();
    }

    // -------------------------

    if($('.page-listicle').length > 0){
        googleListicle();
    }

    // -------------------------

    if($('.page-proof').length > 0){
        proofPage();
    }

    // -------------------------

    if($('.template-login').length > 0){
        var queryParams = new URLSearchParams(window.location.search);
        if(queryParams.has('return_to')){
            $('form#customer_login').append('<input type="hidden" name="return_to" value="' + queryParams.get('return_to') + '">');
        }

        $('.register-content-form-terms').click(function(){
            openPopup('Password vergessen', $('.register-content-forgot-password').html(), function(){
                $('#popup #popup-content form').submit();
            });
        });

        if(window.location.href.indexOf('#recover') !== -1){
            openPopup('Password vergessen', 'Wir haben dir eine E-Mail zum Zurücksetzen deines Passwortes geschickt.');
        }
    }

    // -------------------------

    // Mobile menu
    $('.header-menu-mobile-menu').click(openMobileMenu);
    $('.mobile-menu-header-close-icon').click(closeMobileMenu);
    $('#mobile-menu-overlay').click(closeMobileMenu);

    // -------------------------

    if(window.location.href.indexOf('#features') !== -1){
        $('html, body').animate({
            scrollTop: $('#features').offset().top - 100
        }, 500);
    }

    // -------------------------

    if($('.template-account').length > 0){
        handleAccount();
    }

    // -------------------------

    if($('.page-page-exists').length > 0){
        $('a[href="/account/register"]').removeAttr('href').attr('onclick', 'openSignUpPopup();');

        mixpanel.track('PageView-Page-Exists');
    }

    // -------------------------

    if(
        $('.page-email-download-link-3').length > 0 || 
        $('.page-email-download-link-4').length > 0 || 
        $('.page-email-download-link-5').length > 0
    ){
        $('.animated-element').addClass('animated-element-show-animation');

        // document.querySelectorAll('.animated-element').forEach(function(node){
        //     node.classList.add('animated-element-show-animation');
        // });
    }

    if(
        $('.page-email-download-link').length > 0 || 
        $('.template-index').length > 0 || 
        $('.page-email-download-link-2').length > 0 || 
        $('.page-email-download-link-3').length > 0 || 
        $('.page-email-download-link-5').length > 0 || 
        $('.page-email-download-link-4').length > 0
    ){
        var queryParams = new URLSearchParams(window.location.search);
        var trafficSource = '';
        if(queryParams.has('traffic-source')){
            $('input[name="customer[tags]"]').attr('value', $('input[name="customer[tags]"]').attr('value') + ',traffic-source-' + queryParams.get('traffic-source'));
            $('input[name="customer[note][source]"]').attr('value', queryParams.get('traffic-source'));

            trafficSource = queryParams.get('traffic-source');

            mixpanel.people.set('traffic-source', queryParams.get('traffic-source'));
        }

        jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
            this.each(function() {
                $(this).css("position","relative"); 
                for (var x=1; x<=intShakes; x++) {
                $(this).animate({left:(intDistance*-1)}, (((intDuration/intShakes)/4)))
            .animate({left:intDistance}, ((intDuration/intShakes)/2))
            .animate({left:0}, (((intDuration/intShakes)/4)));
            }
          });
        return this;
        };

        $('a[href="/account/register"]').removeAttr('href').attr('onclick', 'emailDownloadLinkButton();');

        var distinctId = '';
        if(mixpanel && mixpanel.get_distinct_id){
            distinctId = mixpanel.get_distinct_id();
        }
        
        if($('.template-index').length > 0){
            apiT(4, distinctId);

            // This line is needed for the email funnel.
            // $('a[href*="products/v2-download"]').removeAttr('href').attr('onclick', 'v2IndexMailPopup();');

            $('.v2-lead-popup-close svg').click(function(){
                $('.v2-lead-popup-content').removeClass('animated-element');
                $('.v2-lead-popup-content').removeClass('animated-element-show-animation');
                
                $('.v2-lead-popup').hide();
            });
        }
        
        mixpanel.track('PageView-Email-Download-Link');

        // Setup utm parameter.
        if(localStorage && localStorage.getItem('utm_source') && localStorage.getItem('utm_source') != ''){
            var utm_source = localStorage.getItem('utm_source') || '';
            var utm_medium = localStorage.getItem('utm_medium') || '';
            var utm_campaign = localStorage.getItem('utm_campaign') || '';
            var utm_content = localStorage.getItem('utm_content') || '';

            $('a[href*="/products/v2-download"]').each(function(){
                $(this).attr('href', $(this).attr('href') + '?utm_source=' + utm_source + '&utm_medium=' + utm_medium + '&utm_campaign=' + utm_campaign + '&utm_content=' + utm_content);
            });
        }
        else if(queryParams.has('utm_source')){
            $('a[href*="/products/v2-download"]').each(function(){
                $(this).attr('href', $(this).attr('href') + '?' + queryParams.toString().replaceAll('/',''));
            });

            // if(localStorage){
                // localStorage.setItem('utm_source', queryParams.get('utm_source').replaceAll('/','') || '');
                // localStorage.setItem('utm_medium', queryParams.get('utm_medium').replaceAll('/','') || '');
                // localStorage.setItem('utm_campaign', queryParams.get('utm_campaign').replaceAll('/','') || '');
                // localStorage.setItem('utm_content', queryParams.get('utm_content').replaceAll('/','') || '');
            // }
        }
        else{
            var utmSource = 'Website-' + (window.screen.width < 768 ? 'Mobile' : 'Desktop');
            if(Shopify.locale != 'de'){
                utmSource += '-' + Shopify.locale;
            }
            
            $('a[href*="/products/v2-download"]').each(function(){
                $(this).attr('href', $(this).attr('href') + '?utm_source=' + utmSource + '&utm_medium=&utm_campaign=&utm_content=');
            });
        }

        // 1. Doppelt ausführen probleme (beim error vielleicht auch shaken)
        // 6. VSL vielleicht auf LandingPage einbauen


        var typingEventSend = false;
        $("#customer-mail-field").on("focus", function(){
            if(!typingEventSend){
                gtag('event', 'conversion', {'send_to': 'AW-11031064953/2ndZCJ_93e4YEPnigowp'});
            }

            typingEventSend = true;
        });

        $('form').on('submit', function(event){
            if(window.landingPageGeneratedDistinctId){
                apiT(9, window.landingPageGeneratedDistinctId);
            }

            $('.email-downlink-link-form-error').hide();

            var formErrorContainer = $(this).find('.email-downlink-link-form-error');
            var email = $(this).find('input[name="customer[email]"]').val();
            if(email == '' || !email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
                formErrorContainer.text('Gebe eine gültige E-Mail Adresse ein.');
                formErrorContainer.show();

                if(
                    $('.page-email-download-link-3').length > 0 || 
                    $('.page-email-download-link-5').length > 0 || 
                    $('.page-email-download-link-4').length > 0
                ){
                    $('form').shake(2, 5, 300);
                }

                event.stopPropagation();
                event.preventDefault();
                return;
            }

            gtag('event', 'conversion', {'send_to': 'AW-11031064953/r24qCKGg3u4YEPnigowp'});

            showLoadingIndicator();

            $(this).find('input[name="customer[password]"]').val((Math.random() + 1).toString(36).substring(2));

            if(window.landingPageGeneratedDistinctId){
                apiT(10, window.landingPageGeneratedDistinctId);

                $('input[name="return_to"]').val('/products/email-download-link-confirm?generatedId=' + window.landingPageGeneratedDistinctId.toString());
            }

            $.ajax({
                type: "POST",
                url: 'https://api.getconrise.com/optin',
                data: {
                    email_address: email.trim(),
                    traffic_source: trafficSource
                },
                dataType: "json"
            });

            /*var postUrl = $(this).attr('action');
            var postData = $(this).serialize();

            $.ajax({
                type: "POST",
                url: postUrl,
                data: postData,
                dataType: "json",
                success: function(data) {
                    mixpanel.identify(email.trim());

                    if(window.landingPageGeneratedDistinctId){
                        apiT(10, window.landingPageGeneratedDistinctId);
                    }

                    var href = '/products/email-download-link-confirm';
                    if(window.landingPageGeneratedDistinctId){
                        href += '?generatedId=' + window.landingPageGeneratedDistinctId.toString();
                    }

                    window.location.href = href;

                    hideLoadingIndicator();
                },
                error: function(response) {
                    hideLoadingIndicator();

                    if(window.landingPageGeneratedDistinctId){
                        apiT(11, window.landingPageGeneratedDistinctId);
                    }

                    var errors = $('.errors', response.responseText);
                    if(errors.length > 0){
                        formErrorContainer.text(errors.html());
                        formErrorContainer.show();
                    }
                }
            });*/
        });

        $('input[name="customer[email]"]').on('keydown', function(){
            $('.email-downlink-link-form-error').hide();
        });

        // Sticky form.
        if($('#sticky-form-container').length > 0){
            var stickyForm = $('#sticky-form-container');

            $(window).scroll(function(){
                if(window.scrollY > 530){
                    if(!stickyForm.hasClass('animate')){
                        stickyForm.addClass('animate');
                    }
                }
                else {
                    stickyForm.removeClass('animate');
                }
            });
        }
    }

    if($('.product-email-download-link-confirm').length > 0){
        var mail = $('.product-email-download-link-confirm').attr('data-email').trim();
        if(mail && mail.length > 0){
            mixpanel.identify(mail);

            var queryParams = new URLSearchParams(window.location.search);
            if(queryParams.has('generatedId')){
                apiT(5, queryParams.get('generatedId'), mail);
            }
        }

        mixpanel.track('ViewContent-Email-Download-Link-Confirm');
    }

    // -------------------------

    if($('.page-direct-download').length > 0){
        $('a[href="/account/register"]').attr('href', '/products/direct-download');

        mixpanel.track('PageView-Direct-Download');
    }
    
    if($('.page-direct-download-install').length > 0 && $('.product-page-v2-download').length == 0){
        var queryParams = new URLSearchParams(window.location.search);
        if(queryParams.has('downloadId')){
            $('.theme-download-button').attr('href', 'https://api.getconrise.com/download?download=' + queryParams.get('downloadId'));
            $('.theme-download-button')[0].click();

            mixpanel.alias(parseInt(queryParams.get('downloadId')));

            if(queryParams.has('email')){
                apiT(8, queryParams.get('email'), queryParams.get('downloadId'));
            }
        }

        $('.theme-download-button').on('click', function(){
            gtag('event', 'conversion', {'send_to': 'AW-11031064953/S4YKCJOG4-4YEPnigowp'});
        });

        $('.step-by-step img').click(function(){
            $('.step-by-step-zoom').empty();
            $('.step-by-step-zoom').html($(this).clone());
            
            $('.step-by-step-zoom').show();
        });

        $('.step-by-step-zoom').click(function(){
            $('.step-by-step-zoom').hide();
        });

        mixpanel.track('PageView-Direct-Download-Install');
    }

    // -------------------------

    if($('.product-page-direct-download').length > 0){
        var queryParams = new URLSearchParams(window.location.search);
        var email = '';
        if(queryParams.has('email')){
            email = queryParams.get('email');
        }

        if(email && email.length > 0){
            mixpanel.identify(email);

            apiT(6, email);
        }

        var trafficSource = '';
        if(queryParams.has('source')){
            trafficSource = queryParams.get('source');
        }

        // Only on desktop we will generate the theme.
        if(window.screen.width > 768){
            window.themeGenerationStartTimestamp = Date.now();

            $.ajax({
                type: "POST",
                url: 'https://api.getconrise.com/download', 
                contentType : 'application/json; charset=utf-8',
                dataType: "json",
                data : JSON.stringify({
                    email_address: email,
                    traffic_source: trafficSource
                }),
                success: function(data) {
                    if(!data || !data.success || !data.downloadId){
                        mixpanel.track('PageView-Direct-Download-Product-Error');
                        alert('Es ist ein Fehler aufgetreten. Bitte lade die Seite nochmal.');
                    }
                    else{
                        var url = '/pages/direct-download-install?downloadId=' + data.downloadId + '&email=' + email;

                        var duration = Date.now() - themeGenerationStartTimestamp;
                        if(duration >= 3000){
                            window.location.href = url;
                        }

                        setTimeout(function(){
                            window.location.href = url;
                        }, 3000 - duration);
                    }
                },
                error: function(response) {
                    mixpanel.track('PageView-Direct-Download-Product-Error');
                    alert('Es ist ein Fehler aufgetreten. Bitte lade die Seite nochmal.');
                }
            });

            mixpanel.track('ViewContent-Direct-Download-Product---Desktop');
            apiT(7, email, 'Desktop');
        }
        else{
            mixpanel.track('ViewContent-Direct-Download-Product---Mobile');
            apiT(7, email, 'Mobile');
        }
        
        mixpanel.track('ViewContent-Direct-Download-Product');
    }

    // -------------------------

    if($('.page-signup-direct-download').length > 0){
        signupByDirectDownload();
    }

    // -------------------------

    if($('.page-hilfe-video').length > 0){
        var queryParams = new URLSearchParams(window.location.search);
        if(queryParams.has('title')){
            $('.page-hilfe-video h1').text(decodeURIComponent(queryParams.get('title')));
        }

        if(queryParams.has('video')){
            $('.page-hilfe-video .iframe-wrapper iframe').attr('src', 'https://www.loom.com/embed/' + queryParams.get('video'));

            if(queryParams.get('video') == 'aec02a7cf99c4f219724e77513843b4f'){
                $('<div style="display: flex; flex-direction: column; align-items: center;"><a href="https://getconrise.com/account" style="margin-bottom: 60px; display: inline-flex;" class="btn">Theme kostenlos herunterladen</a></div>').insertAfter('.page-hilfe-video h1');
            }
        }
    }

    // -------------------------

    if($('.page-direct-download-help').length > 0){
        $('.page-direct-download-help').addClass('page-direct-download-install');
    }

    // -------------------------

    if($('.page-purchase-plan').length > 0){
        if(handleOseid()){
            return;
        }

        var queryParams = new URLSearchParams(window.location.search);
        if(queryParams.has('plan')){
            showLoadingIndicator();
            buyTheme(queryParams.get('plan'), queryParams.has('discount') && queryParams.get('discount') == 'true');
        }
        else{
            alert('Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.');
        }
    }

    // -------------------------

    if($('.page-trail-expired').length > 0){
        new Swiper(".swiper", {
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            autoplay:{
                delay: 4000,
                disableOnInteraction: false
            }
        });
    }

    // -------------------------

    if($('.page-discounted-trail').length > 0){
        $('a[href="/account/register"]').removeAttr('href').attr('onclick', "buyTheme('high-conversions', false, true);");

        window.addEventListener("focus", hideLoadingIndicator);

        mixpanel.track('Discount-Trail-Landingpage');
    }

    // -------------------------

    if($('.page-discounted-trail-first').length > 0){
        var queryParams = new URLSearchParams(window.location.search);
        var trafficSource = '';
        if(queryParams.has('traffic-source')){
            trafficSource = queryParams.get('traffic-source');
        }

        $('a[href="/account/register"]').attr('href', '/products/discounted-trail-second?traffic-source=' + trafficSource);

        mixpanel.track('Discount-Trail-Landingpage');
    }

    if($('.product-page-discounted-trail-second').length > 0){
        $('.btn-glow').click(function(){
            mixpanel.track('Discount-Trail-Landingpage-Second-Cart');

            buyTheme('high-conversions', false, true);
        });

        mixpanel.track('Discount-Trail-Landingpage-Second');
    }

    // -------------------------

    if(
        $('.product-page-conrise').length > 0 || 
        $('.product-page-one-time-purchase').length > 0 || 
        $('.product-page-one-time-purchase-regular').length > 0 || 
        $('.product-page-conrise-call').length > 0 || 
        $('.product-page-conrise-high-call').length > 0
    ){
        if(handleOseid()){
            return;
        }

        $('form#AddToCartForm').submit(function(event){
            event.preventDefault();
    
            var queryParams = new URLSearchParams(window.location.search);
            if(queryParams.has('download-id')){
                $('#download-id').val(queryParams.get('download-id'));
            }
            if(queryParams.has('store')){
                $('#store-field').val(queryParams.get('store'));
            }

            var formData = $(this).serialize()
    
            showLoadingIndicator();
    
            $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                dataType: 'json',
                success: function(){
                    $.ajax({
                        type: 'POST', 
                        url: '/cart/add.js',
                        dataType: 'json', 
                        data: formData,
                        success: function(data){
                            window.location.href = '/checkout';
                        },
                        error:function(response){
                            hideLoadingIndicator();
            
                            if(response && response.responseJSON && response.responseJSON.description){
                                alert(response.responseJSON.message + "\n\n" + response.responseJSON.description);
                            }
                            else{
                                alert('Es ist ein Fehler aufgetreten. Bitte versuch es noch einmal.');
                            }
                        }
                    });
                }
            });
        });
    
        $('form#AddToCartForm').submit();
    }

    // -------------------------

    if($('.page-update').length > 0){
        $('#updater-form').on('submit', function(e){
            e.preventDefault();

            showLoadingIndicator();

            var formData = new FormData(this);
            var queryParams = new URLSearchParams(window.location.search);
            if(queryParams.has('force')){
                formData.append("force", true);
            }            

            $.ajax({
                type: "POST",
                url: 'https://api.getconrise.com/v2/theme-update',
                data: formData,
                processData: false,
                contentType: false,
                xhrFields: {
                    responseType: 'blob'
                },
                success: function(response){
                    hideLoadingIndicator();

                    var link = $('#updater-form a');
                    link.attr('href', URL.createObjectURL(response));
                    link[0].click();

                    $('#updater-form input').val('');
                },
                error:function(response){
                    hideLoadingIndicator();
                    alert(response);
                }
            });
        });

        $('#updater-form button').click(function(){
            $('#updater-form input').trigger('click');
        });

        $('#updater-form input').change(function(){
            if($(this).val() != ''){
                $('#updater-form').submit();
            }
        });
    }

    // -------------------------

    if($('.product-page-v2-download').length > 0){
        // Setup loom video.
        var videos = {
            de: {
                desktop: '82e72c05800143d8b26280116c556c29?sid=12ec7c06-1676-4e91-be8e-409e16f01220',
                android: '746b50b76ef248fa92ef74fcb903ff38?sid=d358a8e2-7268-4957-82d4-bdbf4278a191', // Previous video: 7198a6464dd0405c98236846385f662c?sid=d6123fd8-27fd-4a0f-b5d2-29dc7835f1fe
                ios: '746b50b76ef248fa92ef74fcb903ff38?sid=d358a8e2-7268-4957-82d4-bdbf4278a191' // Real ios video: a3fb711d2cdd4efc9910c6f2c266e7fd?sid=966ab28d-c6f4-4e6b-bfff-5f9448909670
            },
            en: {
                desktop: 'f8ddb9e534284554932df5d43f093048?sid=c38757f6-3a47-44e8-b4f8-c5ba7a8519bc',
                android: 'b829fe22c76c4da9910e901d490e5754?sid=0db4bf14-4e0e-4890-9a8c-369b510f3e64',
                ios: 'b829fe22c76c4da9910e901d490e5754?sid=0db4bf14-4e0e-4890-9a8c-369b510f3e64' // Android version
            }
        };

        var lang = Shopify.locale;
        var device = 'desktop';
        var paddingBottom = '56.25%';

        if(window.screen.width < 768){
            device = 'android';
            paddingBottom = '177.77777777777777%';

            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                device = 'ios';    
            }
        }

        $('.' + device + '-step-by-step').show();

        $('#loom').css('padding-bottom', paddingBottom);
        $('#loom iframe').attr('src', 'https://www.loom.com/embed/' + videos[lang][device] + '&hideEmbedTopBar=true');

        // Start download on page load.
        var queryParams = new URLSearchParams(window.location.search);
        var distinctId = null;
        if(queryParams.has('distinctId')){
            distinctId = queryParams.get('distinctId');
        }

        // Setup utm parameter
        if(queryParams.has('utm_source') || queryParams.has('email')){
            $('.theme-download-button').each(function(){
                $(this).attr('href', $(this).attr('href') + '&' + queryParams.toString().replaceAll('/','').replaceAll('%2F',''));
            });
        }

        // Show pre-download video
        if(queryParams.has('hide-pre-download-video')){
            $('.product-page-v2-download-pre-video').hide();
        }
        else{
            $('.product-page-v2-download-pre-video iframe').attr('src', 'https://www.loom.com/embed/12f2c5dce3ad415181973b0e831c85f2?sid=b8f3ad3c-9759-400d-9abb-051c864a0e75&hideEmbedTopBar=true');
        }

        if(!isInAppBrowser() && window.location.hash != '#form_send'){
            // Not needed the ios check, we could directly trigger the download.
            // In the same time the conversion rate dropped.
            if(device == 'ios'){
                setTimeout(function(){
                    $('.theme-download-button')[0].click();
                }, 3000);
            }
            else{
                $('.theme-download-button')[0].click();
            }

            apiT(21, distinctId);
        }
        else{
            apiT(20, distinctId);
        }

        if(queryParams.has('show-download-button')){
            $('.product-page-v2-download-email').hide();
            $('.theme-download-button').removeClass('not-show');
        }

        // Handle step by step image clicks.
        if(window.screen.width > 768){
            $('.step-by-step img').click(function(){
                $('.step-by-step-zoom').empty();
                $('.step-by-step-zoom').html($(this).clone());
                
                $('.step-by-step-zoom').show();
            });

            $('.step-by-step-zoom').click(function(){
                $('.step-by-step-zoom').hide();
            });
        }

        // Handle special scoll.
        $('.helpvideo-headline u').click(function(){
            $('html, body').animate({
                scrollTop: $('#loom')[0].offsetTop - 30
            }, 500);
        });

        // Reviews.
        new Swiper(".v2-customers-reviews-list", {
            slidesPerView: 1.35,
            spaceBetween: 30,
            loop: true,
            centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 45,
                    loop: false,
                    centeredSlides: false,
                    slideToClickedSlide: false
                }
            }
        });

        // Email form.
        $('form').on('submit', function(event){
            var formErrorContainer = $(this).find('.product-page-v2-download-email-error');
            formErrorContainer.hide();

            var email = $(this).find('input[name="customer[email]"]').val();
            if(email == '' || !email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
                formErrorContainer.show();

                $(this).find('.product-page-v2-download-email').shake(2, 5, 300);

                event.stopPropagation();
                event.preventDefault();
                return;
            }

            showLoadingIndicator();

            $(this).find('input[name="customer[password]"]').val((Math.random() + 1).toString(36).substring(2));

            apiT(23);
        });

        $('input[name="customer[email]"]').on('keydown', function(){
            $('.product-page-v2-download-email-error').hide();
        });

        if(window.location.hash == '#form_send'){
            $('.product-page-v2-download-email-success').css('display', 'flex');
        }
    }

    // -------------------------

    if($('.v2-browser-redirect').length > 0){
        if(isTikTokInAppBrowser()){
            $('.menu-step-2-text b').text($('.menu-step-2-text').data().translateTiktok);
            $('.optin-done-confirm-step').css('flex', 'none');
            $('.optin-done-confirm-step:eq(1)').css('margin-top', '30px');
            $('.required-steps-info').css('margin-bottom', '25px');
            $('.optin-done-confirm-step img').css('transform', 'rotate(90deg)');
        }
        // Handle device.
        else if(getDevice() == 'ios'){
            $('.menu-step-2-text b').text($('.menu-step-2-text').data().translateIos);
            $('.optin-done-confirm-step').css('flex', 'none');
            $('.optin-done-confirm-step:eq(1)').css('margin-top', '30px');
            $('.required-steps-info').css('margin-bottom', '25px');
            $('.optin-done-confirm-step img').css('transform', 'rotate(90deg)');
        }

        // Line.
        var titles = document.getElementsByClassName('optin-done-confirm-step-title');
        var stepHeight = titles[1].offsetTop - titles[0].offsetTop;
        
        document.getElementsByClassName('optin-done-confirm-icons-line')[0].style.height = stepHeight + 'px';

        // Setup arrow size.
        var text = $('.menu-step-1-text')[0];
        $('.menu-arrow').css({
            width: (window.screen.width - text.offsetLeft - text.offsetWidth - 20 - 15 - 10) + 'px',
            height: (text.offsetTop - 20 - 10) + 'px'
        });

        // Add shake method.
        jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
            this.each(function() {
                $(this).css("position","relative"); 
                for (var x=1; x<=intShakes; x++) {
                $(this).animate({left:(intDistance*-1)}, (((intDuration/intShakes)/4)))
            .animate({left:intDistance}, ((intDuration/intShakes)/2))
            .animate({left:0}, (((intDuration/intShakes)/4)));
            }
          });
        return this;
        };

        // Handle shake.
        $('.optin-done-confirm-step-title').click(function(){
            $(this).parent().find('p').shake(2, 5, 300);
        });
    }

    // -------------------------

    // Handle animated elements.
    if($('.animated-element:not(.animated-element-show-animation)').length > 0){
        var windowScrollTop = 0;
        var animatedElementFunction = function(){
            windowScrollTop = $(this).scrollTop() + Math.ceil(window.screen.height * 0.85);

            $('.animated-element:not(.animated-element-show-animation)').each(function(index, element){
                if(windowScrollTop >= element.offsetTop){
                    $(element).addClass('animated-element-show-animation');
                }
            });
        };
        $(window).scroll(animatedElementFunction);
        animatedElementFunction();

        // Show instant.
        $('.animated-element-instant').each(function(index, element){
            $(element).addClass('animated-element-show-animation');
        });
    }

    // -------------------------

    if($('.page-help-center').length > 0){
        // Trigger close in theme-editor.
        $('.help-dashboard-header svg').click(function(){
            window.parent.postMessage("conrise:close-help-center", '*');
        });

        /*$('.help-dashboard-help a').click(function(){
            window.parent.postMessage({
                event_id: 'conrise:help-center-mailto',
                data: {
                    href: $(this).attr('data-href')
                }
            }, '*');
        });*/

        $('.help-dashboard-menu div').click(function(){
            $('.help-dashboard-menu div').removeClass('selected');
            $(this).addClass('selected');
    
            $('.help-dashboard-content .help-dashboard-content-entry').hide();
            $('.help-dashboard-content .help-dashboard-content-entry[data-type="' + $(this).attr('data-type') + '"]').css('display', 'flex');
        });
    
        $('.help-dashboard-menu div:eq(0)').click();
    
        $('.help-dashboard-help .btn').click(function(){
            var number = $('.help-dashboard-help input').val().trim();
            if(!number || number.length == 0){
                return;
            }
    
            $.ajax({
                type: "POST",
                url: 'https://api.getconrise.com/v2/marketing?number=' + number,
                contentType : 'application/json; charset=utf-8'
            });
    
            $('.help-dashboard-help .marketing-subscribed').show();
        });

        $('.help-dashboard-video-overlay').click(function(){
            var fullscreen = $('#help-dashboard-videos-fullscreen');
            fullscreen.css('display', 'flex');
            fullscreen.find('h2').text($(this).parents('.help-dashboard-video').find('h2').text());
            fullscreen.find('iframe').attr('src', $(this).parent().find('.help-dashboard-video-video iframe').attr('src'));
        });

        $('#help-dashboard-videos-fullscreen button').click(function(){
            $('#help-dashboard-videos-fullscreen').hide();

            var fullscreen = $('#help-dashboard-videos-fullscreen');
            fullscreen.find('iframe').attr('src', '');
        });
    }

    // -------------------------

    if($('.page-purchase-call').length > 0 || $('.page-purchase-expired-call').length > 0){
        window.location.href = window.location.href.replace('-call', '');
        return;
    }

    if(
        $('.page-purchase').length > 0 || 
        $('.page-purchase-expired').length > 0 || 
        $('.page-purchase-call').length > 0 || 
        $('.page-purchase-expired-call').length > 0
    ){
        var queryParams = new URLSearchParams(window.location.search);
        var language = 'de';
        var store = '';
        var trailEndDate = 0;
        var shopName = '';
        var trailExpired = false;
        var noLicense = false;
        var offerUpgrade = false;
        var type = 'DOWNLOAD';
        var version = '';

        if(queryParams.has('version')){ version = queryParams.get('version'); }
        if(queryParams.has('language')){ language = queryParams.get('language'); }
        if(queryParams.has('store')){ store = queryParams.get('store'); }
        if(queryParams.has('trailenddate')){ trailEndDate = parseInt(queryParams.get('trailenddate')); }
        if(queryParams.has('shopname')){ shopName = queryParams.get('shopname'); }
        if(queryParams.has('trailexpired')){ trailExpired = queryParams.get('trailexpired') == 'true' ? true : false; }
        if(queryParams.has('nolicense')){ noLicense = queryParams.get('nolicense') == 'true' ? true : false; }
        if(queryParams.has('offerupgrade')){ offerUpgrade = queryParams.get('offerupgrade') == 'true' ? true : false; }
        if(queryParams.has('t')){ 
            var tParam = queryParams.get('t');
            if(tParam == 'c'){
                type = 'CALL';
            }
            else if(tParam == 'hc'){
                type = 'HIGH_CALL';
            }
        }

        if(type != 'DOWNLOAD'){
            $('.offer-expired').css('display', 'flex');
            $('.test-running').css('display', 'none');

            $('.starter-trail-expired-tr-cta-price').text('749€');
            if(type == 'HIGH_CALL'){
                $('.starter-trail-expired-tr-cta-price').text('2.497€');
            }

            $('.starter-trail-expired-content-box-or').hide();
            $('.starter-trail-expired-content-box-sub').hide();
            $('.starter-trail-expired-content-boxes').css('padding-bottom', '100px');

            $('.purchase-button').each(function(){
                if(type == 'CALL'){
                    $(this).attr('href', $(this).attr('href').replace('one-time-purchase-regular', 'conrise-call'));
                }
                else if(type == 'HIGH_CALL'){
                    $(this).attr('href', $(this).attr('href').replace('one-time-purchase-regular', 'conrise-high-call'));
                }
            });
        }

        if(trailExpired || noLicense){
            $('.offer-expired').css('display', 'flex');
            $('.test-running').css('display', 'none');

            if(noLicense){
                $('.starter-trail-expired-popup-header svg').hide();

                $('.starter-trail-expired-content-eyebrow').html($('.starter-trail-expired-content-eyebrow').attr('data-expired'));
                $('.starter-trail-expired-content-header .container h1').html($('.starter-trail-expired-content-header .container h1').attr('data-expired'));
                $('.starter-trail-expired-content-header .container p').html($('.starter-trail-expired-content-header .container p').attr('data-expired'));

                if(type != 'DOWNLOAD'){
                    $('.starter-trail-expired-content-header .container h1').text($('.starter-trail-expired-content-header .container h1').text().replace('30', '7'));
                }

                $('.starter-trail-expired-content-header .container h1').css({
                    'font-size': '40px',
                    'line-height': '45px'
                });
                $('.starter-trail-expired-content-header .container p').css({
                    'font-size': '19px',
                    'line-height': '27px',
                    'max-width': '670px'
                });
            }
        }

        if(offerUpgrade){
            $('.starter-trail-expired-popup-header svg').show();
            $('#starter-trail-expired-popup').addClass('offer-upgrade');
            $('.starter-trail-expired-content-header .container h1').html($('.starter-trail-expired-content-header .container h1').attr('data-upgrade-translation'));
            $('.offer-expired .starter-trail-expired-content-offer-headline').html($('.offer-expired .starter-trail-expired-content-offer-headline').attr('data-upgrade-translation'));
            $('.starter-trail-expired-content-offer-advantage:eq(0) span').html($('.starter-trail-expired-content-offer-advantage:eq(0) span').attr('data-upgrade-translation'));
            $('.starter-trail-expired-content-offer-advantage:eq(1) span').html($('.starter-trail-expired-content-offer-advantage:eq(1) span').attr('data-upgrade-translation'));
            $('.starter-trail-expired-content-offer-advantage:eq(2) span').html($('.starter-trail-expired-content-offer-advantage:eq(2) span').attr('data-upgrade-translation'));
        }

        if(!shopName){
            shopName = language == 'de' ? 'deinem Onlineshop' : 'your shop';
        }

        // Links.
        $('.purchase-button').each(function(){
            $(this).attr('href', $(this).attr('href') + store);
        });

        // View setup.
        // Swift text to html.
        if($('.page-purchase-expired').length == 0){
            $('.starter-trail-expired-content-header .container p').html($('.starter-trail-expired-content-header .container p').text().replace('{shopName}', shopName));
        }
        
        $('.starter-trail-expired-content-box-sub p').html($('.starter-trail-expired-content-box-sub p').text());

        new Swiper("#starter-trail-expired-popup .review-swiper", {
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            autoplay:{
                delay: 4000,
                disableOnInteraction: false
            }
        });

        new Swiper(".v2-customers-reviews-list", {
            slidesPerView: 1.35,
            spaceBetween: 30,
            loop: true,
            centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 45,
                    loop: false,
                    centeredSlides: false,
                    slideToClickedSlide: false
                }
            }
        });

        $('.starter-trail-expired-content-header-review span').each(function(){
            $(this).html($(this).text());
        });

        $('.starter-trail-expired-tr-gift, .starter-trail-expired-tr-gift-benefit, .starter-trail-expired-tr-cta-headline, .starter-trail-expired-tr-cta-text, .starter-trail-expired-tr-cta-price').each(function(){
            $(this).html($(this).text());
        });

        $('.starter-trail-expired-popup-header svg').click(function(){
            window.parent.postMessage("conrise:close-sales-view", '*');
        });

        // Handle version.
        if(version != '2.0.2'){
            $('.starter-trail-expired-content-header h1').html($('.starter-trail-expired-content-header h1').html().replace('14', '30'));

            var tickHeaderContainer = $('.starter-trail-expired-tr-cta-text');
            tickHeaderContainer.html(tickHeaderContainer.html().replace('14-tägiger', '30-tägiger'));
            
            var benefitContainer = $('.starter-trail-expired-content-offer.test-running .starter-trail-expired-content-offer-description.starter-trail-expired-tr-gift-benefit');
            benefitContainer.html(benefitContainer.html().replace('14-tägigen', '30-tägigen'));
        }

        // Setup countdown ticker.
        var tickerFunc = function(){
            Tick.count.down(new Date(trailEndDate)).onupdate = function(value){
                window.countdownTicker.value = value;
            };
        };

        if(window.countdownTicker){
            tickerFunc();
        }
        else{
            $(document).on('TickerInit', tickerFunc);
        }
    }

    // -------------------------

    if($('.page-zoom').length > 0){
        var queryParams = new URLSearchParams(window.location.search);
        var date = 0;
        var title = '';
        var link = '';
        
        if(queryParams.has('date')){ date = parseInt(queryParams.get('date')); }
        if(queryParams.has('title')){ title = queryParams.get('title'); }
        if(queryParams.has('link')){ link = queryParams.get('link'); }

        if(new Date(date).getTime() <= Date.now()){
            $('.zoom-call-popup-content-buttons a').addClass('btn-glow');
        }
        else{
            setTimeout(function(){
                $('.zoom-call-popup-content-buttons a').addClass('btn-glow');
            }, new Date(date).getTime() - Date.now());
        }

        $('#zoom-call-popup-content h1').html(title);
        
        $('#zoom-call-popup-content p:eq(0)').html($('#zoom-call-popup-content p:eq(0)').text());
        $('#zoom-call-popup-content p:eq(1)').html($('#zoom-call-popup-content p:eq(1)').text());

        $('.zoom-call-popup-content-link').html(link);
        $('.zoom-call-popup-content-buttons a').attr('href', link);

        $('#zoom-call-popup-content .btn-secondary').click(function(){
            window.parent.postMessage("conrise:close-zoom-view", '*');
        });
    }

    // -------------------------

    if($('.page-router').length > 0){
        /*var queryParams = new URLSearchParams(window.location.search);
        if(queryParams.has('oseid')){
            queryParams.delete('oseid');
        }

        if(queryParams.has('route')){
            var route = queryParams.get('route');

            if(queryParams.has('encoded') && queryParams.get('route') == true){
                route = decodeURIComponent(route);
            }

            var queryParamsCheck = new URLSearchParams(route);
            if(queryParamsCheck.has('oseid')){
                queryParamsCheck.delete('oseid');

                route = queryParamsCheck.toString();
            }

            window.location.href = route;
        }*/
    }

    // -------------------------------

    if($('.page-bootcamp').length > 0){
        $('.bootcamp-video-link').click(function(){
            $('.bootcamp-video-link').removeClass('active');
            $(this).addClass('active');

            $('.bootcamp-video-container h2').text($(this).text());
        });

        new Swiper(".v2-customers-reviews-list", {
            slidesPerView: 1.35,
            spaceBetween: 30,
            loop: true,
            centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 45,
                    loop: false,
                    centeredSlides: false,
                    slideToClickedSlide: false
                }
            }
        });
    }

    // -------------------------------

    if($('.page-purchase').length > 0 || $('.page-purchase-expired').length > 0){
        $('.sales-view-faq-entry').click(function(){
            var p = $(this).find('p');

            if(p.css('display') == 'none'){
                p.show();
            }
            else{
                p.hide();
            }
        });

        $('.sales-view-scroll-top').click(function(){
            $('html, body').animate({
                scrollTop: $('.starter-trail-expired-content-boxes').offset().top - 90
            }, 500);
        });
    }

});

function handleOseid(){
    var queryParamsCheck = new URLSearchParams(window.location.search);
    if(queryParamsCheck.has('oseid')){
        queryParamsCheck.delete('oseid');

        window.location.href = 'https://api.getconrise.com/router?route=' + encodeURIComponent(window.location.origin + window.location.pathname + '?' + queryParamsCheck.toString());

        return true;
    }

    return false;
}

function handleTickInit(tick){
    // Setup translations.
    var locale = {
        YEAR_PLURAL: 'Jahre',
        YEAR_SINGULAR: 'Jahr',
        MONTH_PLURAL: 'Monate',
        MONTH_SINGULAR: 'Monat',
        WEEK_PLURAL: 'Wochen',
        WEEK_SINGULAR: 'Woche',
        DAY_PLURAL: 'Tage',
        DAY_SINGULAR: 'Tag',
        HOUR_PLURAL: 'Stunden',
        HOUR_SINGULAR: 'Stunde',
        MINUTE_PLURAL: 'Minuten',
        MINUTE_SINGULAR: 'Minute',
        SECOND_PLURAL: 'Sekunden',
        SECOND_SINGULAR: 'Sekunde',
        MILLISECOND_PLURAL: 'Millisekunden',
        MILLISECOND_SINGULAR: 'Millisekunde'
    };

    if(Shopify.locale == 'en'){
        locale.DAY_PLURAL = 'Days';
        locale.DAY_SINGULAR = 'Day';
        locale.HOUR_PLURAL = 'Hours';
        locale.HOUR_SINGULAR = 'Hour';
        locale.MINUTE_PLURAL = 'Minutes';
        locale.MINUTE_SINGULAR = 'Minute';
        locale.SECOND_PLURAL = 'Seconds';
        locale.SECOND_SINGULAR = 'Second';
    }

    for (var key in locale) {
        if (!locale.hasOwnProperty(key)) { continue; }
        tick.setConstant(key, locale[key]);
    }

    // Setup handler.
    window.countdownTicker = tick;
    $(document).trigger('TickerInit');
}

function getDevice(){
    if(window.screen.width < 768){
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            return 'ios';
        }

        return 'android';
    }

    return 'desktop';
}

function showDemoCallPopup(){
    $('#v2-demo-call').css('display', 'flex');
    $('main').hide();
}

function hideDemoCallPopup(){
    $('#v2-demo-call').css('display', 'none');
    $('main').show();
}

function isInAppBrowser(){
    /*if(localStorage && localStorage.getItem('conrise_isInAppBrowser')){
        return true;
    }*/

    return navigator.userAgent.match(/FBAN|FBAV|Instagram|Byte/i) ? true : false;
}

function isTikTokInAppBrowser(){
    return navigator.userAgent.match(/Byte/i) ? true : false;
}

function setInAppBrowser(){
    if(localStorage){
        localStorage.setItem('conrise_isInAppBrowser', true);
    }
}

function apiT(type, d, ed){
    var obj = {
        type: type
    };

    if(d){
        obj.d = d;
    }

    if(ed){
        obj.ed = ed;
    }

    $.ajax({
        type: "POST",
        url: 'https://api.getconrise.com/t', 
        data : JSON.stringify(obj),
        contentType : 'application/json; charset=utf-8',
        success: function(data) {
            // Server-Landingpage.
            if(data && data.id){
                /*window.landingPageGeneratedDistinctId = data.id;

                if($('.template-index').length > 0 && window.landingPageGeneratedDistinctId != ''){
                    $('a[href="/products/v2-download"]').each(function(){
                        $(this).attr('href', $(this).attr('href') + '?distinctId=' + window.landingPageGeneratedDistinctId);
                    });
                }*/
            }
        }
    });
}

function openMobileMenu(){
    $('#mobile-menu').css('visibility', 'visible');

    $('#mobile-menu-overlay').css('opacity', '0.5');
    $('#mobile-menu-content').css('transform', 'translateX(0%)');
}

function closeMobileMenu(){
    setTimeout(function(){
        $('#mobile-menu').css('visibility', 'hidden');
    }, 200);

    $('#mobile-menu-overlay').css('opacity', '0');
    $('#mobile-menu-content').css('transform', 'translateX(100%)');
}

function showLoadingIndicator(){
    $('#loading-indicator').css('display', 'flex');
}

function hideLoadingIndicator(){
    $('#loading-indicator').css('display', 'none');
}

function openPopup(headline, text, callback, cancelCallback, big){
    $('#popup').css('visibility', 'visible');

    if(big){
        $('#popup-content').css({
            top: '5%',
            width: '60%'
        });
    }
    else{
        $('#popup-content').css({
            top: '40%',
            width: '35%'
        });
    }

    $('#popup-content h2').html(headline);
    $('#popup-content p').html(text);

    if(!callback){
        callback = function(){
            $('#popup').css('visibility', 'hidden');
        };
    }
    if(!cancelCallback){
        cancelCallback = function(){
            $('#popup').css('visibility', 'hidden');
        };
    }

    $('#popup-content .btn-ok').unbind('click');
    $('#popup-content .btn-ok').click(callback);

    $('#popup-content .btn-secondary').unbind('click');
    $('#popup-content .btn-secondary').click(cancelCallback);
}

function openHelpVideoPopup(title, video){
    openPopup(
        title, 
        '<div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/' + video + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>', 
        function(){
            $('#popup-content p').empty();
            $('#popup').css('visibility', 'hidden');
        }, 
        function(){
            $('#popup-content p').empty();
            $('#popup').css('visibility', 'hidden');
        }, 
        true
    );
}

function openSignUpPopup(){
    mixpanel.track('SignUp-Popup-Opened');

    $('#signup-popup').css('visibility', 'visible');

    $('#signup-popup-overlay').unbind('click');
    $('#signup-popup-overlay').click(function(event){
        $('#signup-popup').css('visibility', 'hidden');
    });

    $('#signup-popup-content .btn').unbind('click');
    $('#signup-popup-content .btn').click(function(event){
        $('.signup-errors').hide();
        $('.signup-errors').html("");

        var firstName = $('#signup-popup input[name="customer[first_name]"]').val();
        var email = $('#signup-popup input[name="customer[email]"]').val();
        var password = $('#signup-popup input[name="customer[password]"]').val();
        var errors = [];

        if(firstName == ''){
            errors.push("<li>Bitte gebe deinen Vornamen an.</li>");
        }
        if(email == ''){
            errors.push("<li>Bitte gebe deine Email-Adresse an.</li>");
        }
        else if(!email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
            errors.push("<li>Bitte gebe eine gültige Email-Adresse an.</li>");
        }
        if(password == ''){
            errors.push("<li>Bitte gebe ein Passwort an.</li>");
        }
        else if(password.length < 6){
            errors.push("<li>Dein Passwort muss mindestens 6 Zeichen lang sein.</li>");
        }

        if(errors.length > 0){
            event.preventDefault();
            
            $('.signup-errors').show();
            $('.signup-errors').html("<ul>" + errors.join('') + "</ul>");
        }

        if(fbq){
            fbq('track', 'Lead');
        }

        mixpanel.track('SignUp-Popup-Submitted');
    });
}

function emailDownloadLinkButton(){
    $('html, body').animate({
        scrollTop: 0
    }, 500, function(){
        $('.main-downlink-form').shake(2, 5, 300);
    });
}

function scrollToPrice(){
    $('html, body').animate({
        scrollTop: $('.price-header').offset().top
    }, 500);
}

function hideHeaderAndFooter(){
    $('#header').hide();
    $('#footer').hide();
}

function handleRegister(){
    var queryParams = new URLSearchParams(window.location.search);
    if(queryParams.has('plan')){
        $('input[name="customer[tags]"]').val('plan-' + queryParams.get('plan'));
    }
    else{
        $('input[name="customer[tags]"]').val('plan-free');
    }

    // Create customer.
    $('form#create_customer').on('submit', function(event){
        event.preventDefault();

        // Do sign up.
        var postUrl = $(this).attr('action');
        var postData = $(this).serialize();

        $('.register-errors').hide();
        $('.register-errors').html("");

        // Check if fields filled.
        if(
            $('input[name="customer[first_name]"]').val() == '' || 
            $('input[name="customer[last_name]"]').val() == '' || 
            $('input[name="customer[email]"]').val() == '' || 
            $('input[name="customer[password]"]').val() == '' || 
            $('input[name="customer[note][store_domain]"]').val() == ''
        ){
            $('.register-errors').show();
            $('.register-errors').html("<ul><li>Bitte fülle alle Felder aus.</li></ul>");
            return;
        }

        showLoadingIndicator();

        // Submit form.
        $.ajax({
            type: "POST",
            url: postUrl,
            data: postData,
            dataType: "json",
            success: function(data) {
                if(fbq){
                    fbq('track', 'Lead');
                }

                window.location.href = '/products/complete-registration';
            },
            error: function(response) {
                var errors = $('.errors', response.responseText);

                $('.register-errors').show();

                if(errors.length > 0){
                    $('.register-errors').html(errors.html());
                }
                else{
                    $('.register-errors').html("<ul><li>Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.</li></ul>");
                }

                hideLoadingIndicator();
            }
        });
    });
}

function signupByDirectDownload(){
    $('form#create_customer').on('submit', function(event){
        event.preventDefault();

        // Do sign up.
        var postUrl = $(this).attr('action');
        var postData = $(this).serialize();

        $('.register-errors').hide();
        $('.register-errors').html("");

        var firstName = $('input[name="customer[first_name]"]').val();
        var email = $('input[name="customer[email]"]').val();
        var password = $('input[name="customer[password]"]').val();
        var domain = '';
        var downloadId = 0;
        var errors = [];

        var queryParams = new URLSearchParams(window.location.search);
        if(queryParams.has('domain')){
            domain = queryParams.get('domain');
        }
        if(queryParams.has('id')){
            downloadId = queryParams.get('id');
        }

        if(!queryParams.has('domain') || !queryParams.has('id')){
            errors.push("<li>Fehlende Parameter.</li>");
        }
        if(firstName == ''){
            errors.push("<li>Bitte gebe deinen Vornamen an.</li>");
        }
        if(email == ''){
            errors.push("<li>Bitte gebe deine Email-Adresse an.</li>");
        }
        else if(!email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
            errors.push("<li>Bitte gebe eine gültige Email-Adresse an.</li>");
        }
        if(password == ''){
            errors.push("<li>Bitte gebe ein Passwort an.</li>");
        }
        else if(password.length < 6){
            errors.push("<li>Dein Passwort muss mindestens 6 Zeichen lang sein.</li>");
        }

        // Check for errors.
        if(errors.length > 0){
            $('.register-errors').show();
            $('.register-errors').html("<ul>" + errors.join('') + "</ul>");
            return;
        }

        showLoadingIndicator();

        // Submit form.
        $.ajax({
            type: "POST",
            url: postUrl,
            data: postData,
            dataType: "json",
            success: function(data) {
                if(fbq){
                    fbq('track', 'Lead');
                }
                
                $.ajax({
                    type: "POST",
                    url: 'https://api.getconrise.com/account-download', 
                    data : JSON.stringify({
                        email_address: email,
                        shopify_domain: domain,
                        downloadId: downloadId
                    }),
                    contentType : 'application/json; charset=utf-8',
                    success: function(response){
                        hideLoadingIndicator();

                        // Error.
                        if(!response.success){
                            $('.register-errors').show();
        
                            if(response.message == 'EMAIL_EXISTS'){
                                $('.register-errors').html("<ul><li>Diese E-Mail Adresse ist bereits vergeben.</li></ul>");
                            }
                            else{
                                $('.register-errors').html("<ul><li>Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.</li></ul>");
                            }
                            
                            return;
                        }
        
                        window.location.href = '/pages/signup-direct-download-confirm';
                    }
                });
            },
            error: function(response) {
                var errors = $('.errors', response.responseText);

                $('.register-errors').show();

                if(errors.length > 0){
                    $('.register-errors').html(errors.html());
                }
                else{
                    $('.register-errors').html("<ul><li>Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.</li></ul>");
                }

                hideLoadingIndicator();
            }
        });
    });
}

function buyTheme(plan, discount, discountedTrail){
    if(plan == 'elite-performance'){
        $('form#AddToCartForm input[name="selling_plan"]').val(688790274379);
    }
    else if(plan == 'high-conversions'){
        $('form#AddToCartForm input[name="selling_plan"]').val(663486566);
    }
    else if(plan == 'revenue-extreme'){
        $('form#AddToCartForm input[name="selling_plan"]').val(663519334);
    }
    else{
        alert('Es ist ein Fehler aufgetreten. Bitte melde dich bei unserem Support an: hello@getconrise.com');
        return;
    }

    if(discountedTrail === true){
        mixpanel.track('Discount-Trail-AddToCart');
    }

    var queryParams = new URLSearchParams(window.location.search);
    if(queryParams.has('store')){
        $('#store-field').val(queryParams.get('store'));
    }

    $('form#AddToCartForm').submit(function(event){
        event.preventDefault();

        var formData = $(this).serialize()

        showLoadingIndicator();

        $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            dataType: 'json',
            success: function(){
                $.ajax({
                    type: 'POST', 
                    url: '/cart/add.js',
                    dataType: 'json', 
                    data: formData,
                    success: function(data){
                        if(discountedTrail === true){
                            var queryParams = new URLSearchParams(window.location.search);
                            if(queryParams.has('traffic-source') && queryParams.get('traffic-source') == 'meta'){
                                window.location.href = 'https://getconrise.com/discount/Erster%2520Monat%2520kostenlos?redirect=/checkout';    
                            }
                            else{
                                window.location.href = 'https://getconrise.com/discount/1.%2520Monat%2520kostenlos?redirect=/checkout';
                            }
                        }
                        else if(discount === true && plan == 'high-conversions'){
                            window.location.href = 'https://getconrise.com/discount/2-Verk%25C3%25A4ufe-Geschenkt?redirect=/checkout';
                        }
                        else{
                            window.location.href = '/checkout';
                        }

                        if(!discountedTrail){
                            hideLoadingIndicator();
                        }
                    },
                    error:function(response){
                        hideLoadingIndicator();
        
                        console.log(response);
        
                        if(response && response.responseJSON && response.responseJSON.description){
                            alert(response.responseJSON.message + "\n\n" + response.responseJSON.description);
                        }
                        else{
                            alert('Es ist ein Fehler aufgetreten. Bitte versuch es noch einmal.');
                        }
                    }
                });
            }
        });
    });

    $('form#AddToCartForm').submit();
}

function buyPlanWhenPageReady(plan){
    $(document).ready(function(){
        buyTheme(plan);
    });
}

function cancelSubscription(email){
    openPopup('Aktuellen Plan kündigen', 'Möchtest du deinen aktuellen Plan kündigen? Damit stehen dir einige sehr wichtige Inhalte nicht mehr zur Verfügung.', function(){
        showLoadingIndicator();

        $.ajax({
            type: "POST",
            url: 'https://api.getconrise.com/subscriptions/cancel', 
            data : JSON.stringify({
                email: email.trim()
            }),
            contentType : 'application/json; charset=utf-8',
            success: function(response){
                hideLoadingIndicator();

                if(response && response.success){
                    openPopup(
                        'Aktuellen Plan kündigen', 
                        'Dein Plan wurde erfolgreich gekündigt.', 
                        function(){
                            window.location.href = '/account';
                        },
                        function(){
                            window.location.href = '/account';
                        }
                    );
                }
                else{
                    openPopup('Aktuellen Plan kündigen', 'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.');
                }                
            },
            error:function(response){
                hideLoadingIndicator();

                openPopup('Aktuellen Plan kündigen', 'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.');
            }
        });
    });
}

function handleAccount(){
    $('.account-header-mobile').click(function(){
        $('.account-menu').show();
    });

    showLoadingIndicator();

    var button = $('.account-theme-download');
    button.click(function(){
        setupAccountDirectDownload(button.attr('data-user-mail'));
    });

    $.ajax({
        type: "GET",
        url: 'https://api.getconrise.com/account?email=' + button.attr('data-user-mail'),
        contentType : 'application/json; charset=utf-8',
        success: function(response){
            hideLoadingIndicator();

            if(!response || !response.success || !response.data){
                return;
            }

            button.unbind('click');
            button.attr('href', 'https://api.getconrise.com/theme?email=' + button.attr('data-user-mail'));
        },
        error:function(response){
            hideLoadingIndicator();
        }
    });

    // Theme update.
    $('#account-theme-update-form').on('submit', function(e){
        e.preventDefault();

        showLoadingIndicator();

        $.ajax({
            type: "POST",
            url: 'https://api.getconrise.com/theme-update?email=' + $(this).attr('data-user-mail'),
            data:  new FormData(this),
            processData: false,
            contentType: false,
            xhrFields: {
                responseType: 'blob'
            },
            success: function(response){
                hideLoadingIndicator();

                var link = $('#account-theme-update-form a');
                link.attr('href', URL.createObjectURL(response));
                link[0].click();

                $('#account-theme-update-form input').val('');
            },
            error:function(response){
                hideLoadingIndicator();
            }
        });
    });

    $('#account-theme-update-form button').click(function(){
        $('#account-theme-update-form input').trigger('click');
    });

    $('#account-theme-update-form input').change(function(){
        if($(this).val() != ''){
            $('#account-theme-update-form').submit();
        }
    });

    if(window.location.href.indexOf('#account-plan') !== -1){
        showLoadingIndicator();
        $('.account-menu-entry[data-content="account-plan"]').click();
        buyPlanWhenPageReady('complete');
    }
}

function openAccountThemePopup(){
    $('#account-theme-popup').css('visibility', 'visible');

    $('#account-theme-popup-content .btn').unbind('click');

    $('#account-theme-popup-content .btn-secondary').click(function(){
        $('#account-theme-popup-content input[name="store_domain"]').val('');
        $('#account-theme-popup').css('visibility', 'hidden');
    });

    $('#account-theme-popup-content .btn-ok').click(function(){
        $('.account-theme-errors').hide();
        $('.account-theme-errors').html("");

        // Handle store domain.
        var storeDomain = $('#account-theme-popup-content input[name="store_domain"]').val();
        storeDomain = storeDomain.replace('https://', '');
        storeDomain = storeDomain.replace('http://', '');
        storeDomain = storeDomain.substr(0, storeDomain.indexOf('.myshopify.com') + 14);
        
        if(storeDomain.indexOf('/admin') !== -1){
            storeDomain = storeDomain.substr(0, storeDomain.indexOf('/admin'));
        }
        
        $('#account-theme-popup-content input[name="store_domain"]').val(storeDomain);

        // Check store domain.
        if(storeDomain.length == 0 || storeDomain.indexOf('.myshopify.com') === -1){
            $('.account-theme-errors').show();
            $('.account-theme-errors').html("<ul><li>Deine Shopify Shop Domain muss in dem folgenden Format angegeben werden: <u>???.myshopify.com</u>. Die <u>???</u> musst du mit deiner Shop Url ersetzen.<br /><br />Du kannst deine Shopify Domain auch aus der Adresszeile deines Browsers kopieren wenn du dich in Shopify eingeloggt hast.</li></ul>");
            return;
        }

        if(storeDomain.indexOf('conrise.myshopify.com') !== -1){
            $('.account-theme-errors').show();
            $('.account-theme-errors').html("<ul><li>\"conrise.myshopify.com\" ist nur ein Beispiel. Bitte verwende deine Shopify Shop Domain.<br /><br />Du kannst deine Shopify Domain auch aus der Adresszeile deines Browsers kopieren wenn du dich in Shopify eingeloggt hast.</li></ul>");
            return;
        }

        // Save domain.
        showLoadingIndicator();

        $.ajax({
            type: "POST",
            url: 'https://api.getconrise.com/account', 
            data : JSON.stringify({
                email_address: $('#account-theme-popup-content input[name="mail"]').val(),
                shopify_domain: $('#account-theme-popup-content input[name="store_domain"]').val(),
                plan: $('#account-theme-popup-content input[name="plan"]').val()
            }),
            contentType : 'application/json; charset=utf-8',
            success: function(response){
                hideLoadingIndicator();

                // Error.
                if(!response.success){
                    $('.account-theme-errors').show();

                    if(response.message == 'EMAIL_EXISTS'){
                        $('.account-theme-errors').html("<ul><li>Diese E-Mail Adresse ist bereits vergeben.</li></ul>");
                    }
                    else{
                        $('.account-theme-errors').html("<ul><li>Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.</li></ul>");
                    }
                    
                    return;
                }

                $('#account-theme-popup-content input[name="store_domain"]').val('');
                $('#account-theme-popup').css('visibility', 'hidden');

                $('.account-theme-download').unbind('click');
                $('.account-theme-download').attr('href', 'https://api.getconrise.com/theme?email=' + $('.account-theme-download').attr('data-user-mail'));
                $('.account-theme-download')[0].click();
            }
        });
    });
}

function setupAccountDirectDownload(email){
    $.ajax({
        type: "POST",
        url: 'https://api.getconrise.com/download', 
        contentType : 'application/json; charset=utf-8',
        data : JSON.stringify({
            email_address: email,
        }),
        success: function(data) {
            if(!data || !data.success || !data.downloadId){
                alert('Es ist ein Fehler aufgetreten. Bitte lade die Seite nochmal.');
            }
            else{
                $('.account-theme-download').unbind('click');
                $('.account-theme-download').attr('href', 'https://api.getconrise.com/download?download=' + data.downloadId);
                $('.account-theme-download')[0].click();
            }
        },
        error: function(response) {
            alert('Es ist ein Fehler aufgetreten. Bitte lade die Seite nochmal.');
        }
    });
}

function v2Index(){
    // Link stuff.
    /*$('a[href*="/products/v2-download"]').each(function(){
        $(this).removeAttr('href');
        $(this).click(showDemoCallPopup);
    });*/

    // --- Header + Steps animation -----------------
    var stepsLineOffsetTop = $('.v2-steps-line').offset().top;
    var stepsLineAnimationPoint = Math.ceil(window.screen.height * (window.screen.width > 768 ? 1.5 : 0.5));
    var header = $('#header');
    var announcementBarHeight = $('.v2-announcement-bar').height();
    var stickyShowPos = announcementBarHeight + header.height();
    var customersOffsetTop = $('.v2-customers-reviews').offset().top - 120;
    var customersOffsetTopMobile = $('.v2-customers-reviews').offset().top + window.screen.height * 0.35;

    header.css({
        'position': 'absolute',
        'top': announcementBarHeight + 'px'
    });
    $('.v2-announcement-bar-spacer').css('height', header.height() + 'px');

    /*if(window.screen.width > 768){
        $('#v2-video-circle').css('left', $('.header-menu .btn').offset().left + $('.header-menu .btn').width() - 30)
    }*/

    var windowScrollTop = 0;
    var windowScroll = function(){
        windowScrollTop = $(this).scrollTop();

        // Desktop.
        if(window.screen.width > 768){
            if(windowScrollTop >= announcementBarHeight){
                // Header.
                header.css({
                    'position': 'fixed',
                    'top': '0px',
                    'box-shadow': '0px 0px 16px -4px rgb(0 0 0 / 20%)'
                });

                // Zoom.
                if(window.zoomCallAvailable){
                    $('#zoom-call-button').css('display', 'flex');
                }
            }
            else{
                // Header.
                header.css({
                    'position': 'absolute',
                    'top': announcementBarHeight + 'px',
                    'box-shadow': 'none'
                });

                // Zoom.
                if(window.zoomCallAvailable){
                    $('#zoom-call-button').hide();
                }
            }
        }
        // Mobile.
        else{
            // Sticky bar.
            if(windowScrollTop >= stickyShowPos){
                $('.v2-sticky-bar').css('display', 'flex');
                $('.v2-sticky-bar').addClass('animate');

                // Zoom.
                if(window.zoomCallAvailable){
                    $('#zoom-call-button').css('display', 'flex');
                }
            }
            else{
                $('.v2-sticky-bar').css('display', 'none');
                $('.v2-sticky-bar').removeClass('animate');

                // Zoom.
                if(window.zoomCallAvailable){
                    $('#zoom-call-button').hide();
                }
            }
        }

        // Handle special animation.
        if(windowScrollTop + stepsLineAnimationPoint >= stepsLineOffsetTop){
            $('.v2-steps-line').addClass('animate');
        }

        /*
        // Video circle.
        // Desktop.
        if(window.screen.width > 768){
            if(windowScrollTop >= customersOffsetTop){
                $('#v2-video-circle').addClass('animation');
            }

            if($('#v2-video-circle').hasClass('animation')){
                if(windowScrollTop < 45){
                    $('#v2-video-circle').css('margin-top', 45 - windowScrollTop);
                }
                else{
                    $('#v2-video-circle').css('margin-top', 0);
                }
            }
        }
        // Mobile.
        else{
            if(windowScrollTop >= customersOffsetTopMobile){
                $('#v2-video-circle').addClass('animation');
            }

            if(windowScrollTop < 75){
                $('#v2-video-circle').css('top', 64 + (75 - windowScrollTop));
            }
            else{
                $('#v2-video-circle').css('top', 64);
            }
        }
        */
    };
    $(window).scroll(windowScroll);
    windowScroll();

    // --- Feature -----------------
    $('.v2-feature-mobile-menu-entry, .v2-feature-menu-entry').click(function(){
        if($(this).hasClass('active')){
            return;
        }

        var isMobile = $(this).is('.v2-feature-mobile-menu-entry');

        $(this).parent().find('.animate').removeClass('animate');

        var oldActive = $(this).parent().find('.active');
        if(isMobile){
            oldActive.removeClass('active');
            $(this).addClass('active');
        }
        else{
            oldActive.find('.v2-feature-menu-entry-content').animate({
                opacity: 0.2
            }, 250, function(){
                oldActive.removeClass('active');
            });

            var thisMenuEntry = $(this);
            $(this).find('.v2-feature-menu-entry-content').animate({
                opacity: 1
            }, 250, function(){
                thisMenuEntry.addClass('active');
            });
        }

        var videoIndex = $(this).attr('data-index');

        $(this).parents('.v2-feature').find('video').each(function(){
            $(this)[0].pause();

            if($(this).attr('data-index') == videoIndex){
                $(this)[0].currentTime = 0;
                $(this)[0].play();

                window.v2FeatureSwiper[parseInt($(this).parents('.v2-feature').attr('data-number')) - 1].slideTo(parseInt(videoIndex) - 1);
            }
        });

        // Mobile.
        if(isMobile){
            var box = $(this).parent().find('.v2-feature-mobile-menu-entry-box');
            box.animate({ left: $(this)[0].offsetLeft }, 150);

            var description = $(this).parents('.v2-feature').find('.v2-feature-mobile-entry-description');
            description.text(description.attr('data-text-' + $(this).attr('data-index')));
        }
    });

    // Start css duration animation.
    $('.v2-feature-media-video video').on('playing', function(){
        // Mobile.
        var stateDiv = $(this).parents('.v2-feature-media').find('.v2-feature-mobile-menu .v2-feature-mobile-menu-entry-state')[0];
        var newStateDiv = stateDiv.cloneNode(true);
        stateDiv.parentNode.replaceChild(newStateDiv, stateDiv);

        newStateDiv.style.animationDuration = $(this)[0].duration.toString() + 's';
        newStateDiv.classList.add('animate');

        // Desktop.
        stateDiv = $(this).parents('.v2-feature').find('.v2-feature-menu-entry[data-index="' + $(this).attr('data-index') + '"] .v2-feature-menu-entry-state')[0];
        newStateDiv = stateDiv.cloneNode(true);
        stateDiv.parentNode.replaceChild(newStateDiv, stateDiv);

        newStateDiv.style.animationDuration = $(this)[0].duration.toString() + 's';
        newStateDiv.classList.add('animate');
    });

    $('.v2-feature-media-video video').on('ended', function(){
        var index = parseInt($(this).attr('data-index')) + 1;
        if(index > 3){
            index = 1;
        }

        // Mobile.
        if(window.screen.width <= 768){
            $(this).parents('.v2-feature-media').find('.v2-feature-mobile-menu-entry[data-index="' + index + '"]').click();
        }
        else{
            $(this).parents('.v2-feature').find('.v2-feature-menu-entry[data-index="' + index + '"]').click();
        }
    });

    // Setup underlaying box.
    $('.v2-feature-mobile-menu-entry-box').each(function(){
        var firstEntry = $(this).parent().find('.active');

        $(this).css({
            left: firstEntry[0].offsetLeft,
            width: firstEntry.outerWidth(),
            height: firstEntry.outerHeight()
        });
    });

    // Setup swiper.
    window.v2FeatureSwiper = new Swiper(".v2-feature-media-video", {
        slidesPerView: 'auto',
        spaceBetween: 50,
        speed: 250,
        resistanceRatio: 0,
        on:{
            slideChange: function(swiper){
                // Mobile
                if(window.screen.width <= 768){
                    $(swiper.el).parents('.v2-feature').find('.v2-feature-mobile-menu-entry[data-index="' + (swiper.activeIndex + 1) + '"]').click();
                }
                else{
                    $(swiper.el).parents('.v2-feature').find('.v2-feature-menu-entry[data-index="' + (swiper.activeIndex + 1) + '"]').click();
                }
            }
        }
    });

    // Zoom.
    $.ajax({
        type: "GET",
        url: 'https://api.getconrise.com/v2/zoom',
        success: function(data){
            if(data && data.zoom){
                window.zoomCallAvailable = true;

                var zoomDate = new Date(data.zoom.date);
                var zoomDateString = zoomDate.getHours().toString().padStart(2, '0') + ':' + zoomDate.getMinutes().toString().padStart(2, '0');
                var title = data.zoom.title.de.replace('{date}', zoomDateString);

                if(zoomDate.getTime() <= Date.now()){
                    $('#zoom-call-button').addClass('on-air');
                    $('.zoom-call-popup-content-buttons a').addClass('btn-glow');
                }
                else{
                    setTimeout(function(){
                        $('#zoom-call-button').addClass('on-air');
                        $('.zoom-call-popup-content-buttons a').addClass('btn-glow');
                    }, zoomDate.getTime() - Date.now());
                }

                $('.zoom-call-button-title').html(title);
        
                $('#zoom-call-popup-content h1').html(title);
                
                $('#zoom-call-popup-content p:eq(0)').html($('#zoom-call-popup-content p:eq(0)').text());
                $('#zoom-call-popup-content p:eq(1)').html($('#zoom-call-popup-content p:eq(1)').text());
        
                $('.zoom-call-popup-content-link').html(data.zoom.link);
                $('.zoom-call-popup-content-buttons a').attr('href', data.zoom.link);

                windowScroll();
            }
        }
    });

    $('#zoom-call-button').click(function(){
        $('#zoom-call-popup').css('display', 'flex');
        $('body').css('overflow', 'hidden');
    });

    $('#zoom-call-popup-content .btn-secondary').click(function(){
        $('#zoom-call-popup').hide();
        $('body').css('overflow', 'auto');
    });

    // Demo-Call.
    $('#v2-demo-call .btn').click(function(){
        var name = $('#v2-demo-call input[name="name"]').val().trim();
        var mobile = $('#v2-demo-call input[name="mobile"]').val().trim();

        $('.v2-demo-call-content-error').hide();

        // Error case.
        if(name.length == 0 || mobile.length < 7){
            $('.v2-demo-call-content-error').show();
            $('#v2-demo-call input, .v2-demo-call-content-error').shake(2, 5, 300);
            return;
        }

        // Success: Save and redirect.
        showLoadingIndicator();

        $.ajax({
            type: "POST",
            url: 'https://api.getconrise.com/v2/lead', 
            contentType : 'application/json; charset=utf-8',
            dataType: "json",
            data: JSON.stringify({
                name: name,
                phone: mobile
            }),
            success: function() {
                window.location.href = '/products/v2-demo-call?name=' + encodeURIComponent(name);
            },
            error: function(response) {
                hideLoadingIndicator();

                alert(response.responseText);
            }
        });
    });

    $('.v2-demo-call-content-close').click(hideDemoCallPopup);

    // Customers reviews.
    new Swiper(".v2-customers-reviews-list", {
        slidesPerView: 1.35,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 45,
                loop: false,
                centeredSlides: false,
                slideToClickedSlide: false
            }
        }
    });

    // Customers videos.
    $('.v2-review-videos-list-entry').click(function(){
        $('.v2-review-videos-popover').css('display', 'block');

        var video = '<script src="https://fast.wistia.com/embed/medias/2ji9357cq7.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:176.67% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_2ji9357cq7 seo=true videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/2ji9357cq7/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>';

        if($(this).attr('data-video') == '2'){
            video = '<script src="https://fast.wistia.com/embed/medias/au06szvihw.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:177.78% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_au06szvihw seo=true videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/au06szvihw/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>';
        }

        $('.v2-review-videos-popover-video').empty();
        $('.v2-review-videos-popover-video').html(video);
    });
    $('.v2-review-videos-overlay').click(function(){
        $('.v2-review-videos-popover').css('display', 'none');
        $('.v2-review-videos-popover-video').empty();
    });

    // Tracking.
    apiT(22);

    // Video Circle.
    /*$('#v2-video-circle').click(function(){
        $('#v2-video-circle-content').show();

        $('#v2-video-circle-content a[href*="/products/v2-download"]').each(function(){
            if($(this).attr('href').indexOf('hide-pre-download-video') == -1){
                if($(this).attr('href').indexOf('?') !== -1){
                    $(this).attr('href', $(this).attr('href') + '&hide-pre-download-video=true');
                }
                else{
                    $(this).attr('href', $(this).attr('href') + '?hide-pre-download-video=true');
                }
            }
        });
    });
    $('#v2-video-circle-content svg').click(function(){
        $('#v2-video-circle-content').hide();

        $('#v2-video-circle-content iframe')[0].contentWindow.postMessage(
            {
                method: 'pause',
                context: 'player.js',
            },
            '*'
        );
    });*/
}

function v2IndexScroll(selector, doCloseMobileMenu){
    if(doCloseMobileMenu){
        closeMobileMenu();
    }

    var offset = 0;

    if(selector == '.v2-feature-1'){
        offset = window.screen.width > 768 ? 70 : 50;
    }
    else if(selector == '.v2-feature-2'){
        offset = window.screen.width > 768 ? 40 : 20;
    }
    else if(selector == '.v2-content-boxes'){
        offset = window.screen.width > 768 ? 180 : 130;
    }
    else if(selector == '.v2-steps'){
        offset = window.screen.width > 768 ? 180 : 140;
    }
    else if(selector == '.v2-pricing'){
        offset = window.screen.width > 768 ? 60 : 20;
    }

    $('html, body').animate({
        scrollTop: $(selector).offset().top - offset
    }, 500);
}

function v2IndexMailPopup(){
    $('.v2-lead-popup').css('display', 'flex');

    $('.v2-lead-popup-content').addClass('animated-element');
    
    setTimeout(function(){
        $('.v2-lead-popup-content').addClass('animated-element-show-animation');
    }, 30);
}

function googleListicle(){
    var queryParams = new URLSearchParams(window.location.search);
    if(queryParams.has('type')){
        var gifType = queryParams.get('type');

        $('.google-listicle-header-gif img').hide();
        $('.google-listicle-header-gif .header-gif-' + gifType).css({
            'display': 'flex',
            'visibility': 'visible'
        });
    }
    else{
        $('.google-listicle-header-gif img').hide();
        $('.google-listicle-header-gif .header-gif-snoop').css({
            'display': 'flex',
            'visibility': 'visible'
        });
    }

    // Links ändern.
    $('.v2-announcement-bar a').removeAttr('onclick');
    $('.v2-announcement-bar a').attr('href', 'https://getconrise.com/');

    $('#header a').removeAttr('onclick');
    $('#header a').attr('href', 'https://getconrise.com/');

    $('.v2-sticky-bar a').removeAttr('onclick');
    $('.v2-sticky-bar a').attr('href', 'https://getconrise.com/');

    var utmContent = 'Shopify';
    if(queryParams.has('ds')){
        utmContent = 'Dropshipping';
    }

    $('a[href="https://getconrise.com/"]').each(function(){
        $(this).attr('href', 'https://getconrise.com/products/v2-download?utm_source=Google&utm_medium=PaidAds&utm_campaign=Listicle&utm_content=' + utmContent + '&traffic-source=google');
    });

    // Header handling.
    var header = $('#header');
    var announcementBarHeight = $('.v2-announcement-bar').height();
    var stickyShowPos = announcementBarHeight + header.height();

    header.css({
        'position': 'absolute',
        'top': announcementBarHeight + 'px'
    });
    $('.v2-announcement-bar-spacer').css('height', header.height() + 'px');

    var windowScrollTop = 0;
    var windowScroll = function(){
        windowScrollTop = $(this).scrollTop();

        // Desktop.
        if(window.screen.width > 768){
            if(windowScrollTop >= announcementBarHeight){
                header.css({
                    'position': 'fixed',
                    'top': '0px',
                    'box-shadow': '0px 0px 16px -4px rgb(0 0 0 / 20%)',
                    'background-color': '#f8f8f8'
                });
            }
            else{
                header.css({
                    'position': 'absolute',
                    'top': announcementBarHeight + 'px',
                    'box-shadow': 'none',
                    'background-color': '#ffffff'
                });
            }
        }
        // Mobile.
        else{
            // Sticky bar.
            if(windowScrollTop >= stickyShowPos){
                $('.v2-sticky-bar').css('display', 'flex');
                $('.v2-sticky-bar').addClass('animate');
            }
            else{
                $('.v2-sticky-bar').css('display', 'none');
                $('.v2-sticky-bar').removeClass('animate');
            }
        }
    };
    $(window).scroll(windowScroll);
    windowScroll();
}

function proofPage(){
    // Customers videos.
    $('.v2-review-videos-list-entry').click(function(){
        $('.v2-review-videos-popover').css('display', 'block');

        var video = '<script src="https://fast.wistia.com/embed/medias/2ji9357cq7.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:176.67% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_2ji9357cq7 seo=true videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/2ji9357cq7/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>';

        if($(this).attr('data-video') == '2'){
            video = '<script src="https://fast.wistia.com/embed/medias/au06szvihw.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:177.78% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_au06szvihw seo=true videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/au06szvihw/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>';
        }

        $('.v2-review-videos-popover-video').empty();
        $('.v2-review-videos-popover-video').html(video);
    });
    $('.v2-review-videos-overlay').click(function(){
        $('.v2-review-videos-popover').css('display', 'none');
        $('.v2-review-videos-popover-video').empty();
    });
}